import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../store/AppContext';
import {
  Avatar,
  Box,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Logout, Person2, KeyboardArrowDown } from '@mui/icons-material';

export default function Navuser() {
  // --- CORE FUNCTIONALITY (UNTOUCHED) ---
  const { state, dispatch } = useContext(AppContext);
  const userData = state?.auth?.result?.data;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    dispatch({
      type: 'LOGOUT',
    });
  };
  // --------------------------------------

  // Helper to get initials safely
  const initials = `${userData?.firstname?.charAt(0) || ''}${userData?.lastname?.charAt(0) ||
    ''}`.toUpperCase();

  return (
    <Box>
      {/* 1. MODERN TRIGGER BUTTON */}
      <Box
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          p: 0.5,
          pr: 1.5,
          borderRadius: '50px', // Pill shape
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: open ? alpha('#1976d2', 0.04) : 'transparent',
          transition: 'all 0.2s',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: alpha('#1976d2', 0.04),
            borderColor: 'primary.light',
          },
        }}
      >
        <Avatar
          sx={{
            height: 36,
            width: 36,
            bgcolor: 'primary.main',
            fontSize: '0.9rem',
            fontWeight: 700,
          }}
        >
          {initials}
        </Avatar>
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <Typography
            variant="subtitle2"
            fontWeight={700}
            color="text.primary"
            sx={{ lineHeight: 1.2 }}
          >
            {userData?.firstname} {userData?.lastname}
          </Typography>
          <Typography variant="body2" fontWeight={600} fontSize="0.7rem" color="text.secondary">
            {userData?.userCategory}
          </Typography>
        </Box>
        <KeyboardArrowDown
          fontSize="small"
          color="action"
          sx={{
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}
        />
      </Box>

      {/* 2. MODERN MENU DROPDOWN */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose} // Auto-close menu when anything inside is clicked
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              mt: 1.5,
              width: 260,
              borderRadius: '16px', // Rounded menu
              filter: 'drop-shadow(0px 8px 24px rgba(0,0,0,0.1))', // Soft deep shadow
              border: '1px solid',
              borderColor: 'divider',
              '& .MuiList-root': {
                p: 1, // Padding inside the menu
              },
            },
          },
        }}
      >
        {/* Profile Info Header */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 2, pb: 2 }}>
          <Avatar
            sx={{
              height: 72,
              width: 72,
              mb: 1.5,
              bgcolor: alpha('#1976d2', 0.1),
              color: 'primary.main',
              fontSize: '2rem',
              fontWeight: 700,
            }}
          >
            {initials}
          </Avatar>
          <Typography variant="subtitle1" fontWeight={700} color="text.primary">
            {userData?.firstname} {userData?.lastname}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
            <Typography
              variant="caption"
              color="primary.main"
              fontWeight={700}
              sx={{ bgcolor: alpha('#1976d2', 0.1), px: 1, py: 0.25, borderRadius: '6px' }}
            >
              {userData?.roleName}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ mb: 1 }} />

        {/* 3. PROPER ROUTING LINKS */}
        <ListItemButton
          component={Link}
          to="/settings?tab=profile"
          sx={{ borderRadius: '8px', mb: 0.5 }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <Person2 fontSize="small" color="action" />
          </ListItemIcon>
          <ListItemText
            primary="My Profile"
            primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
          />
        </ListItemButton>

        <ListItemButton
          onClick={logout}
          component={Link}
          to="/"
          sx={{
            borderRadius: '8px',
            color: 'error.main',
            '&:hover': {
              bgcolor: alpha('#ff4842', 0.08), // Soft red hover
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <Logout fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText
            primary="Log Out"
            primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
          />
        </ListItemButton>
      </Menu>
    </Box>
  );
}
